var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-visual-badge.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"visualBadge");
frame.set("visualBadge", t_1, true);
if(frame.topLevel) {
context.setVariable("visualBadge", t_1);
}
if(frame.topLevel) {
context.addExport("visualBadge", t_1);
}
if(runtime.contextOrFrameLookup(context, frame, "visualBadge")) {
output += "<span class=\"c-product-detail-visual-badge ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "visualBadge"), env.opts.autoescape);
output += "\" data-qa-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "visualBadge"), env.opts.autoescape);
output += ">\n        ";
output += runtime.suppressValue((lineno = 4, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "linkedSvg"), "linkedSvg", context, ["badge-" + "" + runtime.contextOrFrameLookup(context, frame, "visualBadge"),"c-product-detail-visual-badge-svg"])), env.opts.autoescape);
output += "\n    </span>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-visual-badge.j2"] , dependencies)